import { logError } from '../toaster'
import { saveAs } from 'file-saver'
import cookies from 'js-cookie'
import { decorateFetch } from '../../api'

interface DownloadArgs {
  readonly organizationID: string
  readonly applicationID: string
}

export async function downloadTemplate({
  organizationID,
  applicationID
}: DownloadArgs) {
  const decoratedFetch = decorateFetch(
    fetch,
    cookies,
    document.location,
    window.localStorage
  )

  let res: Response
  try {
    res = await decoratedFetch(
      `/Contrast/api/ng/${organizationID}/applications/${applicationID}/stig/template`,
      {
        method: 'GET'
      }
    )
  } catch (e) {
    return logError('Failed to download file')
  }

  let filename = 'download'

  if (res) {
    if (!res.ok || res.status >= 400) {
      return logError('Failed to download file')
    }

    let blob: Blob
    try {
      blob = await res.blob()
    } catch (e) {
      return logError('Failed to download file')
    }

    const contentDisposition = res.headers.get('content-disposition')

    if (contentDisposition) {
      filename = parse(contentDisposition)
    }

    try {
      saveAs(blob, filename)
    } catch (e) {
      return logError('Failed to download file')
    }
  }
}

function parse(str: string) {
  str = str.slice('attachment; filename="'.length - 1)
  return str.slice(0, str.length)
}
